import { authenticatedFetch } from '../../../api/utils/request';

export default async function getDoctorUsers(setErrorMessage,isDeletedFilter) {
    const onError = () => setErrorMessage('No se pueden obtener usuarios');
    return await authenticatedFetch(`/doctor-user-management/with-approval?isDeleted=${isDeletedFilter}`, onError);
}
